
define('services/common/langService',['app'], function (app) {
    return app.factory('langService', ['OpenOther', function (OpenOther) {


        function getLangItemByLang(langTemp) {
            if (!langTemp){
                return;
            }
            var langCookie = langTemp;
            var langCountries = sysParamCfg.displaylangCountries;
            for(var i = 0;i < langCountries.length;i++){
                // 如果匹配到某个语种就用某个语种，使用indexof这种匹配，这样，所有的
                if (langCookie && langCookie.indexOf(langCountries[i]['key']) != -1){
                    return langCountries[i];
                }
            }
        }

        return {
            getLangItemByLang: getLangItemByLang
        }

    }]);
});


